import { ApiCore } from '@/services/api/utils/core.js'

const url = 'dex'
const plural = 'dexes'
const single = 'dex'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

export default api
